/* eslint-disable */
import Swiper from 'swiper';
(function () {
  'use strict';

  const breakpoint = window.matchMedia('(min-width:992px)');
  let partnerSwiper;
  const row = $('.js-attributes');
  const slide = $('.js-attribute-col');
  const addSwiperElements = (container, slide) => {
    slide.addClass('swiper-slide');
    container.addClass('js-attribute-swiper');
    container.wrapInner('<div class="swiper-wrapper"></div>');
  };
  const enableSwiper = function () {
    addSwiperElements(row, slide, false);
    partnerSwiper = new Swiper('.js-attribute-swiper', {
      slidesPerView: 2,
      loop: true,
      spaceBetween: 14,
      centeredSlides: true,
      observer: true,
      pagination: {
        row: '.swiper-pagination',
        type: 'bullets'
      }
    });
  };
  const removeSwiperElements = (container, slide) => {
    slide.removeClass('swiper-slide');
    slide.unwrap();
    container.removeClass('swiper');
  };
  const breakpointChecker = function () {
    // if larger viewport and multi-row layout needed
    if (breakpoint.matches === true) {
      // clean up old instances and inline styles when available
      if (partnerSwiper !== undefined) {
        removeSwiperElements(row, slide);
        partnerSwiper.destroy(true, true);
      }
      // or/and do nothing
      return;
      // else if a small viewport and single column layout needed
    } else if (breakpoint.matches === false) {
      // fire small viewport version of swiper
      return enableSwiper();
    }
  };

  // keep an eye on viewport size changes
  breakpoint.addListener(breakpointChecker);
  // kickstart
  breakpointChecker();
})(); /* IIFE end */